import { gql } from '@apollo/client';

export const getAssignedBPList = gql`
  query getAssignedBPList(
    $selectedBusinessUserID: String!
    $searchKeyword: String
    $pagination: PaginationInput!
  ) {
    SalesforceManagement {
      queries {
        getAssignedBPList(
          selectedBusinessUserID: $selectedBusinessUserID
          status: ACTIVE
          keywordSearch: $searchKeyword
          pagination: $pagination
        ) {
          paging {
            pageNumber
            pageSize
            totalCount
          }
          items {
            salesforceManagement_AssignedBP_Id
            businessPartner_Id
            businessPartner_PersonID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    FullName
                  }
                }
              }
            }
            salesforceManagement_AssignedBP_BusinessUserID {
              id
            }
            salesforceManagement_AssignedBP_BusinessPartnerID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Code
                    PersonID {
                      id
                      views {
                        SalesforceManagement_all {
                          properties {
                            FullName
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getAssignedLinesListQuery = gql`
  query getAssignedLinesList(
    $selectedBusinessUserID: String!
    $selectedBusinessPartnerID: [String]
    $selectedLineID: [String]
    $selectedPlanID: [String]
  ) {
    SalesforceManagement {
      queries {
        getDistinctAssignedBPLineListWithoutPagination(
          selectedBusinessPartnerID: $selectedBusinessPartnerID
          selectedLineID: $selectedLineID
          selectedPlanID: $selectedPlanID
          selectedBusinessUserID: $selectedBusinessUserID
        ) {
          salesforceManagement_AssignedBPPlan_LineID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Id
                  Name
                  ExternalCode
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const createProposal = gql`
  mutation createProposal(
    $lineID: String!
    $sublineID: String!
    $planID: String!
    $primaryBP: String!
    $primaryPercentage: Decimal!
    $secondaryBP: String
    $secondaryPercentage: Decimal
    $additionalBP: String
    $additionalPercentage: Decimal
    $policyCurrency: String!
    $selectedAssignedBPPlan: String!
    $isGroup: Boolean!
  ) {
    production {
      actions {
        createProposal(
          lineID: $lineID
          sublineID: $sublineID
          planID: $planID
          primaryBP: $primaryBP
          primaryPercentage: $primaryPercentage
          secondaryBP: $secondaryBP
          secondaryPercentage: $secondaryPercentage
          additionalBP: $additionalBP
          additionalPercentage: $additionalPercentage
          policyCurrency: $policyCurrency
          selectedAssignedBPPlan: $selectedAssignedBPPlan
          isGroup: $isGroup
        ) {
          id
        }
      }
    }
  }
`;

export const getActiveAssignedBPPlanList = gql`
  query getActiveAssignedBPPlanList(
    $selectedBusinessUserID: String!
    $selectedBusinessPartnerID: String
    $selectedLineID: String
    $selectedPlanID: String
    $selectedSublineID: String
  ) {
    SalesforceManagement {
      queries {
        getActiveAssignedBPPlanList(
          pagination: { pageNumber: 1, pageSize: 999 }
          selectedBusinessUserID: $selectedBusinessUserID
          selectedBusinessPartnerID: $selectedBusinessPartnerID
          selectedLineID: $selectedLineID
          selectedPlanID: $selectedPlanID
          selectedSublineID: $selectedSublineID
        ) {
          items {
            salesforceManagement_AssignedBPPlan_Id
            plan_Id
            subline_Id
            salesforceManagement_AssignedBPPlan_PlanID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    ExternalCode
                    Name
                    PlanCurrency {
                      Code
                    }
                    SublineID {
                      id
                      views {
                        PlanConfigManagement_all {
                          properties {
                            ExternalCode
                            Name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
